import arActions from "./locales/ar/actions.json" with { type: "json" };
import arAppointments from "./locales/ar/appointments.json" with {
	type: "json",
};
import arAssistant from "./locales/ar/assistant.json" with { type: "json" };
import arAuth from "./locales/ar/auth.json" with { type: "json" };
import arBranches from "./locales/ar/branches.json" with { type: "json" };
import arCheckIn from "./locales/ar/check_in.json" with { type: "json" };
import arClinical from "./locales/ar/clinical.json" with { type: "json" };
import arCommon from "./locales/ar/common.json" with { type: "json" };
import arDashboard from "./locales/ar/dashboard.json" with { type: "json" };
import arDental from "./locales/ar/dental.json" with { type: "json" };
import arDerma from "./locales/ar/derma.json" with { type: "json" };
import arFinance from "./locales/ar/finance.json" with { type: "json" };
import arInbox from "./locales/ar/inbox.json" with { type: "json" };
import arInpatient from "./locales/ar/inpatient.json" with { type: "json" };
import arInsights from "./locales/ar/insights.json" with { type: "json" };
import arLab from "./locales/ar/lab.json" with { type: "json" };
import arLoyalty from "./locales/ar/loyalty.json" with { type: "json" };
import arMedications from "./locales/ar/medications.json" with { type: "json" };
import arNotifications from "./locales/ar/notifications.json" with {
	type: "json",
};
import arObgyn from "./locales/ar/obgyn.json" with { type: "json" };
import arPackages from "./locales/ar/packages.json" with { type: "json" };
import arPatients from "./locales/ar/patients.json" with { type: "json" };
import arPeds from "./locales/ar/peds.json" with { type: "json" };
import arPhotos from "./locales/ar/photos.json" with { type: "json" };
import arPortal from "./locales/ar/portal.json" with { type: "json" };
import arPublic from "./locales/ar/public.json" with { type: "json" };
import arQueue from "./locales/ar/queue.json" with { type: "json" };
import arRadiology from "./locales/ar/radiology.json" with { type: "json" };
import arReviews from "./locales/ar/reviews.json" with { type: "json" };
import arSettings from "./locales/ar/settings.json" with { type: "json" };
import arTasks from "./locales/ar/tasks.json" with { type: "json" };
import arWalkIn from "./locales/ar/walk_in.json" with { type: "json" };
import ckbActions from "./locales/ckb/actions.json" with { type: "json" };
import ckbAppointments from "./locales/ckb/appointments.json" with {
	type: "json",
};
import ckbAssistant from "./locales/ckb/assistant.json" with { type: "json" };
import ckbAuth from "./locales/ckb/auth.json" with { type: "json" };
import ckbBranches from "./locales/ckb/branches.json" with { type: "json" };
import ckbCheckIn from "./locales/ckb/check_in.json" with { type: "json" };
import ckbClinical from "./locales/ckb/clinical.json" with { type: "json" };
import ckbCommon from "./locales/ckb/common.json" with { type: "json" };
import ckbDashboard from "./locales/ckb/dashboard.json" with { type: "json" };
import ckbDental from "./locales/ckb/dental.json" with { type: "json" };
import ckbDerma from "./locales/ckb/derma.json" with { type: "json" };
import ckbFinance from "./locales/ckb/finance.json" with { type: "json" };
import ckbInbox from "./locales/ckb/inbox.json" with { type: "json" };
import ckbInpatient from "./locales/ckb/inpatient.json" with { type: "json" };
import ckbInsights from "./locales/ckb/insights.json" with { type: "json" };
import ckbLab from "./locales/ckb/lab.json" with { type: "json" };
import ckbLoyalty from "./locales/ckb/loyalty.json" with { type: "json" };
import ckbMedications from "./locales/ckb/medications.json" with {
	type: "json",
};
import ckbNotifications from "./locales/ckb/notifications.json" with {
	type: "json",
};
import ckbObgyn from "./locales/ckb/obgyn.json" with { type: "json" };
import ckbPackages from "./locales/ckb/packages.json" with { type: "json" };
import ckbPatients from "./locales/ckb/patients.json" with { type: "json" };
import ckbPeds from "./locales/ckb/peds.json" with { type: "json" };
import ckbPhotos from "./locales/ckb/photos.json" with { type: "json" };
import ckbPortal from "./locales/ckb/portal.json" with { type: "json" };
import ckbPublic from "./locales/ckb/public.json" with { type: "json" };
import ckbQueue from "./locales/ckb/queue.json" with { type: "json" };
import ckbRadiology from "./locales/ckb/radiology.json" with { type: "json" };
import ckbReviews from "./locales/ckb/reviews.json" with { type: "json" };
import ckbSettings from "./locales/ckb/settings.json" with { type: "json" };
import ckbTasks from "./locales/ckb/tasks.json" with { type: "json" };
import ckbWalkIn from "./locales/ckb/walk_in.json" with { type: "json" };
import enActions from "./locales/en/actions.json" with { type: "json" };
import enAppointments from "./locales/en/appointments.json" with {
	type: "json",
};
import enAssistant from "./locales/en/assistant.json" with { type: "json" };
import enAuth from "./locales/en/auth.json" with { type: "json" };
import enBranches from "./locales/en/branches.json" with { type: "json" };
import enCheckIn from "./locales/en/check_in.json" with { type: "json" };
import enClinical from "./locales/en/clinical.json" with { type: "json" };
import enCommon from "./locales/en/common.json" with { type: "json" };
import enDashboard from "./locales/en/dashboard.json" with { type: "json" };
import enDental from "./locales/en/dental.json" with { type: "json" };
import enDerma from "./locales/en/derma.json" with { type: "json" };
import enFinance from "./locales/en/finance.json" with { type: "json" };
import enInbox from "./locales/en/inbox.json" with { type: "json" };
import enInpatient from "./locales/en/inpatient.json" with { type: "json" };
import enInsights from "./locales/en/insights.json" with { type: "json" };
import enLab from "./locales/en/lab.json" with { type: "json" };
import enLoyalty from "./locales/en/loyalty.json" with { type: "json" };
import enMedications from "./locales/en/medications.json" with { type: "json" };
import enNotifications from "./locales/en/notifications.json" with {
	type: "json",
};
import enObgyn from "./locales/en/obgyn.json" with { type: "json" };
import enPackages from "./locales/en/packages.json" with { type: "json" };
import enPatients from "./locales/en/patients.json" with { type: "json" };
import enPeds from "./locales/en/peds.json" with { type: "json" };
import enPhotos from "./locales/en/photos.json" with { type: "json" };
import enPortal from "./locales/en/portal.json" with { type: "json" };
import enPublic from "./locales/en/public.json" with { type: "json" };
import enQueue from "./locales/en/queue.json" with { type: "json" };
import enRadiology from "./locales/en/radiology.json" with { type: "json" };
import enReviews from "./locales/en/reviews.json" with { type: "json" };
import enSettings from "./locales/en/settings.json" with { type: "json" };
import enTasks from "./locales/en/tasks.json" with { type: "json" };
import enWalkIn from "./locales/en/walk_in.json" with { type: "json" };

export const resources = {
	ar: {
		common: arCommon,
		auth: arAuth,
		patients: arPatients,
		appointments: arAppointments,
		assistant: arAssistant,
		settings: arSettings,
		clinical: arClinical,
		inpatient: arInpatient,
		dashboard: arDashboard,
		photos: arPhotos,
		portal: arPortal,
		notifications: arNotifications,
		actions: arActions,
		public: arPublic,
		insights: arInsights,
		queue: arQueue,
		check_in: arCheckIn,
		walk_in: arWalkIn,
		medications: arMedications,
		lab: arLab,
		loyalty: arLoyalty,
		inbox: arInbox,
		finance: arFinance,
		branches: arBranches,
		reviews: arReviews,
		dental: arDental,
		packages: arPackages,
		derma: arDerma,
		obgyn: arObgyn,
		peds: arPeds,
		radiology: arRadiology,
		tasks: arTasks,
	},
	en: {
		common: enCommon,
		auth: enAuth,
		patients: enPatients,
		appointments: enAppointments,
		assistant: enAssistant,
		settings: enSettings,
		clinical: enClinical,
		inpatient: enInpatient,
		dashboard: enDashboard,
		photos: enPhotos,
		portal: enPortal,
		notifications: enNotifications,
		actions: enActions,
		public: enPublic,
		insights: enInsights,
		queue: enQueue,
		check_in: enCheckIn,
		walk_in: enWalkIn,
		medications: enMedications,
		lab: enLab,
		loyalty: enLoyalty,
		inbox: enInbox,
		finance: enFinance,
		branches: enBranches,
		reviews: enReviews,
		dental: enDental,
		packages: enPackages,
		derma: enDerma,
		obgyn: enObgyn,
		peds: enPeds,
		radiology: enRadiology,
		tasks: enTasks,
	},
	// Kurdish Sorani (RTL, Arabic script). All namespaces are now translated
	// to Sorani. Strings still need a native-speaker review of medical
	// terminology, but key parity with `ar` is enforced (see scripts), so
	// there is never a missing key or English leak.
	ckb: {
		common: ckbCommon,
		auth: ckbAuth,
		patients: ckbPatients,
		appointments: ckbAppointments,
		assistant: ckbAssistant,
		settings: ckbSettings,
		clinical: ckbClinical,
		inpatient: ckbInpatient,
		dashboard: ckbDashboard,
		photos: ckbPhotos,
		portal: ckbPortal,
		notifications: ckbNotifications,
		actions: ckbActions,
		public: ckbPublic,
		insights: ckbInsights,
		queue: ckbQueue,
		check_in: ckbCheckIn,
		walk_in: ckbWalkIn,
		medications: ckbMedications,
		lab: ckbLab,
		loyalty: ckbLoyalty,
		inbox: ckbInbox,
		finance: ckbFinance,
		branches: ckbBranches,
		reviews: ckbReviews,
		dental: ckbDental,
		packages: ckbPackages,
		derma: ckbDerma,
		obgyn: ckbObgyn,
		peds: ckbPeds,
		radiology: ckbRadiology,
		tasks: ckbTasks,
	},
} as const;

export type ResourceKey = keyof typeof resources.ar;
export type Locale = keyof typeof resources;

export const defaultNS = "common" as const;
export const fallbackLng = "ar" as const;
